module.exports = __webpack_public_path__ + "img/foton40black.c22c50f2.png";